import { render, staticRenderFns } from "./bulletItem.vue?vue&type=template&id=6c3aa896"
import script from "./bulletItem.vue?vue&type=script&lang=js"
export * from "./bulletItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports